import { ActionButton as CommonActionButton } from '@monorepo/common';
import type { ActionButtonProps } from '@monorepo/common';

function ActionButton({ color, bgColor, outlined, ...props }: Omit<ActionButtonProps, 'variant'>) {
  return <CommonActionButton color={color} bgColor={bgColor} outlined={outlined} {...props} />;
}

export default ActionButton;
